export default __webpack_public_path__ + "static/media/icon-scholar.91129bb1.svg";